import { computed as pcomputed, effect as peffect, signal as psignal, } from '@preact/signals-core';
import { implementService } from '@wix/services-definitions';
import { SignalsServiceDefinition, } from '@wix/services-definitions/core-services/signals';
export const SignalsServiceFactory = implementService(SignalsServiceDefinition, () => {
    return {
        signal: (initialValue) => {
            const sig = psignal(initialValue);
            const signal = {
                get: () => sig.value,
                set: (newValue) => (sig.value = newValue),
                peek: () => sig.peek(),
            };
            return signal;
        },
        computed: (fn) => {
            const sig = pcomputed(fn);
            const signal = {
                get: () => sig.value,
                peek: () => sig.peek(),
            };
            return signal;
        },
        effect: peffect,
    };
});
